import styled from 'styled-components';

export const MainPanel = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;
export const FrontContentWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;
